
import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { SystemService } from '../../../../services/system.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ExcelService } from 'src/app/shared/excel';
import { flatMap, map } from 'rxjs/operators';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Component({
  selector: 'app-actions-log',
  templateUrl: './actions-log.html',
  styleUrls: ['./actions-log.css']
})
export class ActionLog implements OnInit, OnDestroy {


  swipeLog$: any;
  onExport: EventEmitter<ActionButtonEvent>;
  rowActionButtons: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];
  topbarActionButton: { icon: string; tooltip: string; eventEmitter: EventEmitter<ActionButtonEvent>; }[];

  columnSettings: ColumnSetting[] = [
    {
      columnId: 'performedBy',
      name: 'PerformedBy'
    },{
      columnId: 'message',
      name: 'Message',
    },
    {
      columnId: 'timeago',
      name: 'Time Ago',
      hideOnMobile: true
    },{
      columnId: 'timestampDate',
      name: 'Date time',
      hideOnMobile: true
    }]


  constructor(
    private route: ActivatedRoute,
    private systemService: SystemService) {

    this.swipeLog$ = this.route.params.pipe(flatMap(({ siteId, systemId }) => {
      console.log({ siteId, systemId });
      return this.systemService.getActionLogs$(siteId, systemId, 2000);
    }), map(logData => {
      return logData.map(logEntry => {
        return { 
          ...logEntry, 
          // timeago: new Date(logEntry['timestamp']*1000),//moment(logEntry['timestamp']).fromNow(), 
          timeago: moment.unix(logEntry['performedAt']).fromNow(),
          timestampDate:moment.unix(logEntry['performedAt']).tz("Europe/Oslo").format("DD.MM.YYYY HH:mm:ssZZ"),
        }
      })
    }));

    // this.swipeLog$.subscribe(v => console.log("v", v))

    // this.onExport = new EventEmitter<ActionButtonEvent>();



    this.topbarActionButton = [
      // { icon: 'assignment_returned', tooltip: 'Add project', eventEmitter: this.onExport }
    ]
  }

  ngOnInit() {

  }

  ngOnDestroy(): void {
  }

  convertToHex(tag){
    if(isNaN(tag)) return "";

    let hexString = String(parseInt(tag).toString(16).toUpperCase()).substr(0, 8);

    let littleEndianHexString = hexString.substr(6, 2) + hexString.substr(4, 2) + hexString.substr(2, 2) + hexString.substr(0, 2)
    
    return littleEndianHexString;
  }
}
